import { FC } from 'react';
import { useAppContext, useSafeState } from '#hooks';
import { dashboardApi } from '#api';
import { HttpStatusCode } from 'axios';

export const RefreshWebsiteSalesButton: FC = () => {

    const { setApiStatus } = useAppContext()
    const [ isLoading, setIsLoading ] = useSafeState<boolean>(false)

    const refreshWebsiteSales = async () => {
        setIsLoading(true)
        try {
            const response = await dashboardApi.refreshWebsiteSales()
            setApiStatus({ code: HttpStatusCode.Ok, message: response.data.message })
        } catch {
            setApiStatus({ code: HttpStatusCode.BadRequest, message: 'Could not fetch the stats' })
        } finally {
            setIsLoading(false)
        }
    }

    if(isLoading) {
        return <div className="lds-hourglass" />
    }


    return <div className='main-dashboard-container pd-m mt-s three-columns-expand-three'>
        <span className='vertical-align'>Click this button to refresh the website sales</span>
        <button onClick={refreshWebsiteSales} className='download-button ml-m pd-s bold'>REFRESH</button>
        <div />
    </div>
}
